export const cloneGuideDraftContent = (content) => JSON.parse(JSON.stringify(content))

export const paragraphsToText = (paragraphs) => (paragraphs || []).join('\n\n')

export const linesToText = (lines) => (lines || []).join('\n')

export const paragraphsFromText = (value) =>
  value
    .split(/\n\s*\n/)
    .map((item) => item.trim())
    .filter(Boolean)

export const linesFromText = (value) =>
  value
    .split('\n')
    .map((item) => item.trim())
    .filter(Boolean)

export const isValidGuideDraftContent = (content) =>
  Boolean(
    content?.cover?.title?.trim() &&
      content.cover.headline?.trim() &&
      content.cover.subheadline?.trim() &&
      content.introduction?.salutation?.trim() &&
      content.introduction.paragraphs?.length &&
      content.introduction.paragraphs.every((paragraph) => paragraph.trim()) &&
      content.chapters?.length &&
      content.chapters.every((chapter) => chapter.title?.trim()) &&
      content.cta?.headline?.trim() &&
      content.cta.subtext?.trim() &&
      content.cta.benefits?.length &&
      content.cta.benefits.every((benefit) => benefit.trim())
  )
